export default __webpack_public_path__ + "static/media/blood1.6b93abaf.jpeg";